// import React from 'react';
// import styles from './About.module.css';
// import html from '../../images/html-5.png';
// import css from '../../images/css.png';
// import sass from '../../images/sass.png';
// import mui from '../../images/mui.png';
// import firebase from '../../images/firebase.png';
// import github from '../../images/github.png';
// import react from '../../images/react.png';
// import js from '../../images/js.png';
// import next from '../../images/next.png';
// import node from '../../images/nodejs.png';
// import { Grid } from '@mui/material';
// import AliceCarousel from 'react-alice-carousel';






// const skills_img = [html, css, sass, js, mui, firebase, github, react, next, node]
// const skills = ['HTML 5', 'CSS 3', 'SASS', 'JavaScript', 'MaterialUI', 'Firebase', 'Github', 'React', "Next.js", 'Node.Js'];


// const skills_elements = skills_img.map((each, id) => {
//   return (
//     <Grid item xl={3} md={2}>
//       <div className={styles.box}>
//         <img src={each} />
//         <p> {skills[id]} </p>
//       </div>
//     </Grid>
//   )
// })






// export default function About () {
//   return (
//     <div className={styles.container}>  
//       <section>
//         <div className={styles.skills}>
//             <Grid container spacing={5}>
//               {skills_elements}
//             </Grid>
//         </div>

//         <div className={styles.engineering}>
//           <h2> Engineering </h2>
//           <p> A frontend web developer with extensive experience in all areas of advanced frontend web development.
//           User interface, testing, and debugging processes are all processes that you should be familiar with. Providing web system design, installation, testing, and maintenance skills.

//           I have all of the tools I need to build JavaScript online applications, and I can function completely independently of them to deliver fast, scalable solutions – performance and scalability are top concerns for me. </p>
//         </div>
//       </section>

//     </div>
//   )
// }
































import React from 'react';
import styles from './About.module.css';
import Carousel from '../Carousel/Carousel'
import Aos from 'aos';
import 'aos/dist/aos.css';




export default function About () {

  React.useEffect(() => {
    Aos.init({duration: 2000})
  }, [])
  
  return (
    <div className={styles.container}>
        <Carousel />
        <section>
        <div className={styles.engineering} data-aos='fade-up'>
          <h2> Engineering </h2>
          <p> A full stack web developer with extensive experience in all areas of advanced web development and engineering.
          User interface, testing, and debugging processes are all processes that I have expertise in. Providing web system design, installation, testing, and maintenance skills. </p>
          
          <br /> <br />
          <p> I have all of the tools I need to build JavaScript online applications, and I can function completely independently of them to deliver fast, scalable solutions – performance and scalability are top concerns for me. </p>
        </div>
        </section>
    </div>
  )
}
































